import { graphql } from "@/api/graphql/types/gql";

export const GetLedgerCreationDataQuery = graphql(`
  query LedgersMsGetLedgerCreationData(
    $request: LedgersMsGetLedgerCreationDataRequest
  ) {
    LedgersMsGetLedgerCreationData(request: $request) {
      category
      isUnavailable
      rawFormData
    }
  }
`);
